import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AssetMode } from '../types';
import META from './useTrackAssetModeSwitched.meta';

export type UseTrackAssetModeSwitchedParams = {
  asset_mode: AssetMode;
};

export const useTrackAssetModeSwitched = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetModeSwitched = useCallback(
    (params: UseTrackAssetModeSwitchedParams) => {
      track(META.name, {
        ...params,
        category: 'asset_details',
      });
    },
    [track],
  );

  return { trackAssetModeSwitched };
};
